<a routerLink="/">
  <img src="../../assets/logowhite.svg" alt="dots n pix logo" id="logoSmall">
</a>
<form>
  <h1>Buy Tickets</h1>
  <fieldset *ngIf='currentStep == "type"'>
    <div class="container">
      <input type="radio" value="early-bird" name="ticketType" id="bird" required  [(ngModel)]="ticketType">
      <span class="radiobutton"></span>
      <p class="type"> Early Bird* </p>
      <p class="price">45€</p>
      <p class="note">(available until june 2020)</p>
    </div>
    <div class="container">
      <input type="radio" value="standard" name="ticketType" id="standard" required [(ngModel)]="ticketType">
      <span class="radiobutton"></span>
      <p class="type"> Standard* </p>
      <p class="price">90€</p>
    </div>
    <div class="container">
      <input type="radio" value="all-in" name="ticketType" id="allIn" required [(ngModel)]="ticketType">
      <span class="radiobutton"></span>
      <p class="type"> All-in* </p>
      <p class="price">250€</p>
      <p class="note">(Light sponsor, free food & drinks)</p>
    </div>
    <div class="container">
      <input type="radio" value="student/teacher" name="ticketType" id="student" required [(ngModel)]="ticketType">
      <span class="radiobutton"></span>
      <p class="type"> Student/Teacher </p>
      <p class="price">Free</p>
    </div>

    <p class="bottomNote">*When you buy more than 6 tickets, you get 10% off</p>
    <a (click)="nextStep('amount')" *ngIf="ticketType != ''" class="next">Next step</a>
  </fieldset>


  <fieldset *ngIf='currentStep == "amount"'>
    <h2>Please select the amount of {{ticketType}} tickets ({{price}} euro/ticket) you'd like to order.</h2>
      <input type="number" name="ticketAmount" id="amount" required  [(ngModel)]="ticketAmount" >

    <p class="bottomNote">When you buy more than 6 tickets, you get 10% off</p>

    <a (click)="nextStep('coaching')" *ngIf="ticketAmount != null" class="next">Next step</a>
    <a (click)="nextStep('type')" class="previous">Previous step</a>

    <p id="price" *ngIf="ticketAmount != null">Total price: {{calculatePrice()}} Euro</p>
  </fieldset>

  <fieldset *ngIf='currentStep == "coaching"'>
    <h2>Are you interested in a coaching session with one of our speakers?</h2>
      <select name="ticketEmail" id="coach" required  [(ngModel)]="ticketCoach" >
      <option value="No">No</option>  
      <option *ngFor="let speaker of sprekers" [value]="speaker['name']">{{speaker['name']}}</option>
      </select>

      <p class="bottomNote">For more information about choaching sessions, <a routerLink="/coaching">click here</a> </p>

    <a (click)="nextStep('email')" *ngIf="ticketCoach != ''" class="next">Next step</a>
    <a (click)="nextStep('amount')" class="previous">Previous step</a>
  </fieldset>

  <fieldset *ngIf='currentStep == "email"'>
    <h2>Please fill in the email where the tickets should be sent to.</h2>
      <input type="email" name="ticketEmail" id="email" required  [(ngModel)]="ticketEmail" >

      <p class="bottomNote">We will only use this email address to send you the tickets you ordered.</p>

    <a (click)="nextStep('payment')" *ngIf="validEmail()" class="next">Next step</a>
    <a (click)="nextStep('coaching')" class="previous">Previous step</a>
  </fieldset>

  <fieldset *ngIf='currentStep == "payment"'>
    <h2>You will now be sent to an external page for the payment.</h2>

    <a (click)="nextStep('done')" *ngIf="validEmail()" class="next">Next step</a>
    <a (click)="nextStep('email')" class="previous">Previous step</a>
  </fieldset>

  <fieldset *ngIf='currentStep == "done"'>
    <h2>Thank you for ordering tickets! We will see you at the event.</h2>

    <a routerLink="/">Back to homepage</a>
  </fieldset>
  
</form>

<img src="../../assets/window.svg" alt="window" class="window1" *ngIf="ticketAmount >= 1">
<img src="../../assets/window.svg" alt="window" class="window2" *ngIf="ticketAmount >= 2">
<img src="../../assets/window.svg" alt="window" class="window3" *ngIf="ticketAmount >= 3">
<img src="../../assets/emptyRocket.svg" alt="rocket" id="rocket">
